import { doc, DocumentReference, getDoc } from 'firebase/firestore'
import leaveRequestServiceConfigs from './configs'
import { db } from '../../firebase/firebase'
import { LeaveRequest, LeaveRequestRaw } from '../../database/tables'
import LeaveRequestTableHelper from '../../database/tables/helpers/leave-request.helper'

export type GetLeaveRequestByIdParams = {
  id: string
}

export default async function getLeaveRequestById(params: GetLeaveRequestByIdParams): Promise<LeaveRequest> {
  return new Promise(async (resolve, reject) => {
    try {
      const docRef = doc(db, leaveRequestServiceConfigs.collectionName, params.id) as DocumentReference<LeaveRequestRaw>
      const docSnap = await getDoc(docRef)

      if (docSnap.exists()) return resolve(LeaveRequestTableHelper.fromRaw({ id: docSnap.id, rawData: docSnap.data() }))
      else throw new Error('Doc not found!')
    } catch (e) {
      return reject(e)
    }
  })
}
